// Every image the admin renders must come from the custom image domain rather than
// Cloudflare's default delivery host: the API can only purge the edge cache of the
// zone it owns (images.nymblecommerce.com), so a re-uploaded image served from the
// default host would keep showing the old picture until the edge TTL expired.
export const IMAGE_CDN_BASE = 'https://images.nymblecommerce.com/cdn-cgi/imagedelivery/pH9SuiVIe-mPijB57aX3RQ';

export type ImageVariant = 'public' | 'small' | 'medium' | 'large';

// Append a cache-busting version to an image URL. The edge cache ignores the query
// string, but the browser cache keys on it, so a fresh version forces the browser to
// refetch after an upload or replace. Returns the URL untouched when no version is given.
export function withImageVersion(url: string, version?: string | number): string {
  if (version === undefined || version === null || version === '') return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}v=${encodeURIComponent(String(version))}`;
}

// Build the delivery URL for a Cloudflare Images id. The id is used as given: callers
// that need lower-casing (flipbook org id / image name) do it themselves.
export function imageUrl(imageId: string, variant: ImageVariant, version?: string | number): string {
  return withImageVersion(`${IMAGE_CDN_BASE}/${imageId}/${variant}`, version);
}
